import Vue from 'vue'
import { hasBetaFeature } from '@/utils/betaFeatures'
import { shortLinkBaseUrl } from '@/utils/shortLinks'

const { VUE_APP_API_HOST } = process.env

// Liens génériques du post creator (source 'composer') : un lien mws.li par URL et par compte, affiché dans
// le texte et l'aperçu ; la Lambda de publication le re-décline ensuite par page × réseau × type de post.

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` })

const currentAccountId = () => {
  try {
    const user = localStorage.user && localStorage.user !== 'undefined' ? JSON.parse(localStorage.user) : null
    return user && user.account
  } catch (e) {
    return null
  }
}

// Réglage du compte url_shortener_enabled (absent de /users/me) : lu une fois via GET /accounts/:id
// (comme LinkMenu.vue pour bitly_token), mis en cache par compte ; settings/account.vue le met à jour après sauvegarde.
const accountSetting = {}

export function setShortenerAccountSetting(enabled) {
  const id = currentAccountId()
  if (id) accountSetting[id] = Promise.resolve(enabled === true)
}

function accountShortenerEnabled() {
  const id = currentAccountId()
  if (!id) return Promise.resolve(false)
  if (!accountSetting[id]) {
    accountSetting[id] = Vue.http.get(`${VUE_APP_API_HOST}/accounts/${id}`, { headers: authHeaders() })
      .then(res => !!(res.body && res.body.account) && res.body.account.url_shortener_enabled === true)
      .catch(() => {
        delete accountSetting[id]
        return false
      })
  }
  return accountSetting[id]
}

// Raccourcisseur actif pour le compte : feature beta (ouverte hors prod) ET réglage activé explicitement (null = désactivé)
export async function composerShortenerEnabled() {
  if (!hasBetaFeature('url_shortener')) return false
  return accountShortenerEnabled()
}

export function isHttpUrl(value) {
  try {
    const parsed = new URL(String(value || '').trim())
    return ['http:', 'https:'].includes(parsed.protocol)
  } catch (e) {
    return false
  }
}

// Texte d'un sticker lien de story pointant vers un lien court : domaine du site d'origine en majuscules, sans www
// (rendu par défaut d'Instagram), comme le pré-remplit la Lambda des stories (stickerLabel) ; null si URL invalide
export function stickerDomainLabel(value) {
  try {
    return new URL(String(value || '').trim()).hostname.replace(/^www\./i, '').toUpperCase() || null
  } catch (e) {
    return null
  }
}

const SHORT_HOSTS = ['mws.li', 's.mws.li']

// URL déjà sur le domaine court (mws.li en prod, s.mws.li ailleurs) : jamais re-raccourcie
export function isShortLinkUrl(value) {
  try {
    const host = new URL(String(value || '').trim()).hostname.toLowerCase()
    return SHORT_HOSTS.includes(host) || host === new URL(shortLinkBaseUrl()).hostname.toLowerCase()
  } catch (e) {
    return false
  }
}

// Cache de session url -> Promise<lien> (requêtes en vol partagées) ; l'engine est idempotent pour 'composer'
const cache = new Map()

export function createComposerShortLink(url) {
  const key = String(url || '').trim()
  if (!cache.has(key)) {
    const request = Vue.http.post(`${VUE_APP_API_HOST}/links`, { url: key, source: 'composer' }, { headers: authHeaders() })
      .then(res => {
        if (!res.body || !res.body.short_url) throw res
        return res.body
      })
      .catch(err => {
        cache.delete(key)
        throw err
      })
    cache.set(key, request)
  }
  return cache.get(key)
}
